var render = function render(){var _vm=this,_c=_vm._self._c;return _c('generic-error',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Erreur de paramétrage du formulaire")]},proxy:true}])},[_c('h1',[_vm._v("Oh oh ! 🙁")]),_c('p',[_vm._v("Aucun paramétrage n'a été trouvé pour ce formulaire: "),_c('pre',[_vm._v(_vm._s(_vm.id))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }